import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { useMultiPieGraphOption } from "./options"

type useMultiPieGraphEventsProps<T> = {
	graphOption: ReturnType<typeof useMultiPieGraphOption<T>>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const useMultiPieGraphEvents = <T,>({
	graphOption: {
		axisDef
	},
	onChangeCondition
}: useMultiPieGraphEventsProps<T>) => {
  const onClickGraph = useCallback(
    (params?: {
      event?: { event?: { ctrlKey?: boolean }},
      data?: { name?: string, code?: string }
    }) => {
      const data = params?.data
      if (!data?.code) return
      onChangeCondition(
        axisDef?.key,
        { code: [data.code], label: data.name ?? '' },
        params?.event?.event?.ctrlKey ? true : false
      )
    },
    [axisDef, onChangeCondition]
  )
	return {
		click: onClickGraph
	}
}